export const demoConfig = [
  {
    name: 'MAC Online System',
    id: 'marorka',
    logo: './mac_system_solutions.png',
    background_color: 'white',
    is_enabled: false,
    type: 'autologged',
  },
  {
    name: 'Marorka',
    id: 'mac_autolog',
    logo: './marorka.jpeg',
    background_color: 'surface',
    is_enabled: false,
    type: 'autologged',
  },
];

export const demoAssets = [
  { imo: '9525900', name: 'ABUYE' },
  { imo: '9708837', name: 'AUGUSTA' },
  { imo: '9622019', name: 'BEAR' },
  { imo: '9708849', name: 'HANDLES' },
  { imo: '9349540', name: 'LUIGI' },
  { imo: '9708875', name: 'NEVADO' },
  { imo: '9732345', name: 'REGAL' },
  { imo: '9349497', name: 'STANLEY' },
  { imo: '9732307', name: 'VERMILION' },
  { imo: '9708825', name: 'WINDOM' },
  { imo: '9777606', name: 'MORGAN' },
  { imo: '9311787', name: 'OMBIGAICHAN' },
  { imo: '9307279', name: 'NUMBUR' },
  { imo: '9238765', name: 'KANCHENJUNGA' },
  { imo: '9349514', name: 'DUWONI' },
  { imo: '9525883', name: 'GADA' },
  { imo: '9525869', name: 'AMALTITAN' },
  { imo: '9732319', name: 'AVALANCHE' },
  { imo: '9635640', name: 'CRESTONE' },
  { imo: '9309409', name: 'OM PARVAT' },
  { imo: '9612789', name: 'BLACKBURN' },
  { imo: '9612997', name: 'SLAGGARD' },
];

const byDemoPriority = (a, b) =>
  Number(b.enabled ?? false) - Number(a.enabled ?? false) ||
  String(a.asset_id).localeCompare(String(b.asset_id));

const asDemoVessel = (asset, name) => ({
  ...asset,
  name: name.toUpperCase(),
  // The register reports active: false for every asset, which would leave the
  // Connections page — gated on active_in_platform — empty. Demo mode already
  // forces sources to look enabled, so do the same for the fleet.
  active_in_platform: true,
});

// The IMOs above were curated for a dataset the demo site no longer reads, so an
// exact-match filter can leave demo mode with no assets at all. Take the curated
// assets the register does still hold, then top the fleet up from the remaining
// assets under the unclaimed demo names.
export const pickDemoFleet = (assets) => {
  const curatedNames = new Map(demoAssets.map((a) => [a.imo, a.name]));

  const curated = assets.filter((asset) => curatedNames.has(asset.asset_id));
  const claimed = new Set(curated.map((asset) => curatedNames.get(asset.asset_id)));
  const spareNames = demoAssets.map((a) => a.name).filter((name) => !claimed.has(name));

  const toppedUp = assets
    .filter((asset) => !curatedNames.has(asset.asset_id))
    .sort(byDemoPriority)
    .slice(0, spareNames.length)
    .map((asset, index) => asDemoVessel(asset, spareNames[index]));

  return [
    ...curated.map((asset) => asDemoVessel(asset, curatedNames.get(asset.asset_id))),
    ...toppedUp,
  ];
};
